import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { catchError, map, Observable, of } from 'rxjs';

import { VCard, VCardImage, VCardModel } from './vcard.generator.model';
import { Builder } from './vcard.generator.utils';

import { USER_DATA_CONFIG, UserDataConfigInterface } from '../configuration/user-data-config.interface';
import { BusinessCardImage } from '../interfaces/commons.interface';

@Injectable()
export class VCardGenerator {
  // Implementation according to RFC 6350
  // https://datatracker.ietf.org/doc/html/rfc6350
  generateVCard(model: VCardModel): Observable<VCard> {
    return this.generateImageDataUrl(model).pipe(
      map((image) =>
        Builder.getInstance()
          .withVersion()
          .withEmail(model)
          .withAdditionalEmail(model)
          .withMobileNumber(model)
          .withPhoneNumber(model)
          .withFacebook(model)
          .withLinkedIn(model)
          .withXing(model)
          .withFormattedName(model)
          .withName(model)
          .withCompanyName(model)
          .withWebsite(model)
          .withPosition(model)
          .withCompanyAddress(model)
          .withMessages(model)
          // .withRevision(model)
          .withPhoto(image)
          .build()
      )
    );
  }

  private generateImageDataUrl(profileImage: BusinessCardImage): Observable<VCardImage | undefined> {
    if (!profileImage.canto_id) return of(undefined);
    return this.httpClient
      .get(
        `${this.vCardConfig.userServiceApiURL}/business-cards/image/base64/${profileImage.canto_id}/-S200x200-FJPEG`,
        { responseType: 'text' }
      )
      .pipe(
        map((dataUrl) => ({
          dataUrl,
          type: 'image/JPEG',
        })),
        catchError(() => of(undefined))
      );
  }

  constructor(private httpClient: HttpClient, @Inject(USER_DATA_CONFIG) private vCardConfig: UserDataConfigInterface) {}
}
